<!-- Skeleton Loader -->
@if (loading) {
  <myp-skeleton-loader
    [type]="skeletonConfig?.type || 'line'"
    [number]="skeletonConfig?.number || 10"
    [extraContainerClass]="skeletonConfig?.extraContainerClass || 'm-y-30'"
    [useRandomWidth]="skeletonConfig?.useRandomWidth"
    [height]="skeletonConfig?.height"
  ></myp-skeleton-loader>
}

<!-- Filter Items List -->
@if (!loading && translatedItems?.length) {
  <ul [class.menu-options]="itemClass === 'menu-option'">
    @for (item of translatedItems; track trackFilterItem($index, item)) {
      @if (shouldShowItem(item)) {
        <li [class]="itemClass" [class.selected]="item._isSelected" [class.active]="item._isSelected">
          <a
            [class.primary-option]="itemClass === 'menu-option'"
            tabindex="0"
            href="javascript:void(0);"
            [class.active]="item._isSelected"
            (keyup.enter)="onItemClick(item)"
            (keyup.space)="onItemClick(item)"
            (click)="onItemClick(item)"
          >
            <!-- Icon/Image -->
            @if (showIcons) {
              @if (iconType === "svg" && item._iconId) {
                <myp-svg [id]="item._iconId" [class]="item.iconClass || ''" [width]="item.iconWidth || 20" [height]="item.iconHeight || 20"></myp-svg>
              }
              @if (iconType === "image" && item._iconPath) {
                <img [src]="item._iconPath" [class]="item.iconClass || 'icon dark-bg'" [alt]="item._label" />
              }
            }

            <!-- Label -->
            <span>{{ item._label }}</span>

            <!-- Badge/Count -->
            @if (showBadges && item._badgeValue) {
              <span [class]="item.badgeClass || 'list-item-badge'">
                @if (item.badgeSrOnly !== false) {
                  <span class="sr-only">total count</span>
                }
                ({{ item._badgeValue }})
              </span>
            }
          </a>

          <!-- Nested Items -->
          @if (nestedItemsKey && item[nestedItemsKey]?.length) {
            <ul class="fui-secondary-categories">
              @for (nestedItem of item[nestedItemsKey]; track trackFilterItem($index, nestedItem)) {
                @if (shouldShowItem(nestedItem)) {
                  <li [class]="nestedItemClass" [class.selected]="nestedItem._isSelected" [class.active]="nestedItem._isSelected">
                    <a
                      tabindex="0"
                      href="javascript:void(0);"
                      [class.active]="nestedItem._isSelected"
                      (keyup.enter)="onItemClick(nestedItem)"
                      (keyup.space)="onItemClick(nestedItem)"
                      (click)="onItemClick(nestedItem)"
                    >
                      <span>{{ nestedItem._label }}</span>

                      @if (showBadges && nestedItem._badgeValue) {
                        <span [class]="nestedItem.badgeClass || 'list-item-badge'">
                          @if (nestedItem.badgeSrOnly !== false) {
                            <span class="sr-only">total count</span>
                          }
                          ({{ nestedItem._badgeValue }})
                        </span>
                      }
                    </a>
                  </li>
                }
              }
            </ul>
          }
        </li>
      }
    }
  </ul>
}

<!-- Action Buttons Slot -->
<ng-content></ng-content>
